import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, input, viewChild } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { Stage } from '@core/stages-types';
import { PreventOrphansPipe } from '@core/user-interface-legacy';

import { AnonymousLearnMoreOverlayComponent } from '../anonymous-learn-more/anonymous-learn-more-overlay.component';

@Component({
  selector: 'rt-anonymous-learn-more-trigger',
  templateUrl: './anonymous-learn-more-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PreventOrphansPipe,
    TranslatePipe,
    CdkOverlayOrigin,
    AnonymousLearnMoreOverlayComponent,
  ],
})
export class AnonymousLearnMoreTriggerComponent {
  public anonymousStage = input.required<Stage>();

  public overlay = viewChild(AnonymousLearnMoreOverlayComponent);
}
